import { Component, input, OnInit, output } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { modeExecutionData } from '../../../data/schemas/data/modeExecution';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { StructureService } from '../../../services/StructureService';
import { StructureResponse } from '../../../data/http/responses/strcuture.res';
import { CommonModule } from '@angular/common';
import { AppService } from '../../../core/app.service';
import { transformString } from '../../../utils/helpers';
import { SelectComponent } from '../../forms/select/select.component';
import { SelectOption } from '../../../data/schemas/selectoption.schema';
import { UiButtonComponent } from '../../button/button.component';

@Component({
  selector: 'app-steptwoactivities',
  imports: [MatIcon, ReactiveFormsModule, CommonModule, SelectComponent, UiButtonComponent],
  templateUrl: './steptwoactivities.component.html',
  styleUrl: './steptwoactivities.component.css'
})
export class SteptwoactivitiesComponent implements OnInit {

  activitiesData = input<any>();
  activitiesChanges = output<any>();
  pmpModeSelected = output<boolean>();

  public structureData: SelectOption[] = [];
  public modeExecutions: SelectOption[] = [];
  public activityForm: FormGroup = new FormGroup({});

  private subscription: Subscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private structureService: StructureService,
    private route: ActivatedRoute,
    private appService: AppService
  ) {
    this.modeExecutions = modeExecutionData.map(item => ({
      value: item.code,
      label: item.label
    }));

    this.activityForm = this.fb.group({
      supervisor: ['', Validators.required],
      modeExecution: [''],
      structureResponsable: ['', Validators.required],
      structureAssociee: this.fb.array([])
    });
  }

  // Getter pour le FormArray des structures associées
  get structureAssocieeFormArray(): FormArray {
    return this.activityForm.get('structureAssociee') as FormArray;
  }

  ngOnInit(): void {
    if (this.activitiesData()) {
      this.activityForm.patchValue(this.activitiesData());

      if (this.activitiesData().structureAssociee && Array.isArray(this.activitiesData().structureAssociee)) {
        while (this.structureAssocieeFormArray.length !== 0) {
          this.structureAssocieeFormArray.removeAt(0);
        }
        this.activitiesData().structureAssociee.forEach((structureId: string) => {
          this.structureAssocieeFormArray.push(this.fb.control(structureId, Validators.required));
        });
      }
    }

    if (this.structureAssocieeFormArray.length === 0) {
      this.addStructureAssociee();
    }

    this.loadStructures();

    this.subscription.add(
      this.activityForm.get('modeExecution')?.valueChanges.subscribe(value => {
        this.pmpModeSelected.emit(value === 'PMP');
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  addStructureAssociee(): void {
    this.structureAssocieeFormArray.push(this.fb.control(''));
  }

  removeStructureAssociee(index: number): void {
    if (this.structureAssocieeFormArray.length > 1) {
      this.structureAssocieeFormArray.removeAt(index);
    } else {
      this.structureAssocieeFormArray.at(0).reset('');
    }
  }

  /** Revenir à l'étape précédente (generales) */
  goBack(): void {
    this.router.navigate([], {
      queryParams: { step: 'generales' },
      relativeTo: this.route
    });
  }

  onSubmitToLocalStorage(): void {
    if (this.activityForm.valid) {
      // Merger avec les données existantes pour ne pas écraser les étapes précédentes
      const existingData = localStorage.getItem('activity');
      let activityData = existingData ? JSON.parse(existingData) : {};

      activityData = {
        ...activityData,
        activites: this.activityForm.value,
      };

      localStorage.setItem('activity', JSON.stringify(activityData));

      // Émettre les données : le parent (add/edit) gère la navigation
      this.activitiesChanges.emit(this.activityForm.value);
    } else {
      this.activityForm.markAllAsTouched();
      console.warn('Formulaire invalide. Veuillez remplir tous les champs requis.');
    }
  }

  loadStructures(): void {
    this.structureService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.structureData = response.data.map((item: StructureResponse) => ({
          value: item.code,
          label: item.code
        }));

        const currentSupervisorValue = this.activityForm.get('supervisor')?.value;
        if (!currentSupervisorValue) {
          const dgStructure = this.structureData.find(structure => transformString(structure.value) === "DG");
          if (dgStructure) {
            this.activityForm.get('supervisor')?.setValue(dgStructure.value);
          }
        }
        this.pmpModeSelected.emit(this.activityForm.get('modeExecution')?.value === 'PMP');
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }
}